<div class="surface-0">
  <app-menubar></app-menubar>
  <p-toast></p-toast>
  <div class="grid">
    <div class="col-2" *ngIf="navbarVisible">
      <app-navbar></app-navbar>
    </div>

    <div class="col-10" [class.col-12]="!navbarVisible">
      <p-table #dt1 [value]="categoriasProdutos" dataKey="id" editMode="row" dataKey="id" [rows]="50"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="[100, 200, 300]" [loading]="loading" [paginator]="true"
        [globalFilterFields]="['id', 'descricao']">

        <ng-template pTemplate="header">
          <tr>
            <th style="min-width:15rem">
              <div class="flex align-items-center">
                ID
                <p-columnFilter type="text" field="id" display="menu"></p-columnFilter>
              </div>
            </th>
            <th style="min-width:15rem">
              <div class="flex align-items-center">
                Descrição
                <p-columnFilter type="text" field="descricao" display="menu"></p-columnFilter>
              </div>
            </th>


            <th style="min-width:10rem">
              <div class="flex align-items-center">
                Actions
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-categoria let-ri="rowIndex" let-editing="editing">
          <tr [pEditableRow]="categoria"
            [ngStyle]="{'background-color': categoria.status  === false ? 'var(--red-50)' : ''}">
            <td>{{ categoria.id }}</td>
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="categoria.descricao">
                </ng-template>
                <ng-template pTemplate="output">
                  {{ categoria.descricao }}
                </ng-template>
              </p-cellEditor>
            </td>
            <!-- <td><button type="button" pButton pRipple (click)="deletarCategoria(categoria.id)" label="Deletar"
              class="p-button-danger" icon=""></button></td> -->
            <td>
              <button *ngIf=" !editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                (click)="onRowEditInit(categoria)" class="p-button-rounded p-button-text"></button>
              <button *ngIf=" !editing" pButton pRipple type="button" icon="pi pi-trash"
                (click)="deletarCategoria(categoria.id)" class="p-button-rounded p-button-text"></button>
              <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                (click)="onRowEditSave(categoria)"
                class="p-button-rounded p-button-text p-button-success mr-2"></button>
              <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                (click)="onRowEditCancel(categoria, ri)"
                class="p-button-rounded p-button-text p-button-danger"></button>

              <button (click)="updateStatusCategory(categoria)" pButton pRipple type="button" icon="pi pi-check"
                class="p-button-rounded p-button-text">
              </button>

              <p-button icon="pi pi-plus" label="" class="ml-2" (click)="showModalStorecategory(categoria)">
              </p-button>

            </td>
          </tr>

        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7">Não foi encontrada nenhuma catgoria.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <!-- modal store category -->
  <p-dialog header="{{ nameStory }}" [modal]="true" [(visible)]="visible"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '60vw', height: '50vh' }">
    <div class="col-12 flex justify-content-between">
      <p-dropdown [options]="companies" [(ngModel)]="selectedCompanies" optionLabel="name"
        (onChange)="onChangeSelected($event)" placeholder="Selecione as empresa" />

      <p-button icon="pi pi-save" label="SAVE" class="ml-2" (click)="saveStoreCompany()">
      </p-button>

    </div>
    <div class="grid">
      <div class="col-6">
        <p-table #dt1 [value]="storeCategories" [(selection)]="storeCategoriesSelected" dataKey="id" [rows]="50"
          [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 20, 40]" [paginator]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="[]"
          scrollDirection="horizontal" [scrollable]="true" [filterDelay]="0" scrollHeight="60rem" editMode="row">
          <ng-template pTemplate="caption">
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>Empresa</th>
              <th>Del</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-code let-ri="rowIndex">
            <tr>
              <td>{{ code.name}}</td>
              <td>
                <p-button icon="pi pi-times" styleClass="p-button-rounded p-button-danger p-button-text"
                  (click)="deleteStoreCategory(ri)">
                </p-button>
              </td>

          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">Não foi encontrada nenhuma categoria.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

       <div class="col-6">
        <p-table #dt1 [value]="currentStoryCompany" [(selection)]="storeCategoriesSelected" dataKey="id" [rows]="50"
          [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 20, 40]" [paginator]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="[]"
          scrollDirection="horizontal" [scrollable]="true" [filterDelay]="0" scrollHeight="60rem" editMode="row">
          <ng-template pTemplate="caption">
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>Empresa</th>
              <th>Categoria</th>
              <th>Del</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-story let-ri="rowIndex">
            <tr>
              <td>{{ story.empresas.nome_fantasia }}</td>
              <td>{{ story.store_categories.description }}</td>
              <td>
                <p-button 
                  icon="pi pi-times" 
                  styleClass="p-button-rounded p-button-danger p-button-text"
                  (click)="deleteStoryCategory(story)">
                </p-button>
              </td>

          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">Não foi encontrada nenhuma categoria.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

  </p-dialog>

</div>